import React, { useContext, useEffect, useRef } from 'react';
import { Attachment } from '../interfaces/Attachment';

interface Context {
  attachments: Attachment[];
}
export type AttachmentContextType = Partial<Context>;
export const AttachmentContext = React.createContext<AttachmentContextType>({});

export const useMultipleAttachments = (ids: string[]) => {
  const context = useContext(AttachmentContext);
  return (context?.attachments || []).filter((attachment) => ids.includes(attachment.id));
}
export const useAttachment = (id: string): Attachment | null => {
  const context = useContext(AttachmentContext);
  return (context?.attachments || []).find((attachment) => attachment.id === id) || null;
}
export const useAttachmentDataUrl = (id: string) => {
  const attachment = useAttachment(id);
  return attachment?.dataUrl || null;
};

export const getDataFromBlob = (data: Blob): Promise<string | null> => {
  return new Promise<string | null>((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onloadend = () => {
      resolve(reader.result+'' || null);
    }
    reader.onerror = () => {
      resolve(null);
    }
  });
}
export const getDataUrl = (mimetype: string, data: string) => {
  return `data:${mimetype};charset=utf-8,${encodeURIComponent(data)}`;
}
export const downloadDocument = (dataUrl: string, filename: string) => {
  const dlAnchorElem = document.createElement('a');
  dlAnchorElem.setAttribute('href', dataUrl);
  dlAnchorElem.setAttribute('download', filename);
  dlAnchorElem.click();
};
